import React, { useCallback } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Card, Col, Form, FormGroup, Modal, ModalBody, Tooltip } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  RSelect,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Link, useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import { useEffect } from "react";
import QRCode from "react-qr-code";
import DatePicker from "react-datepicker";
import CopyToClipboard from "react-copy-to-clipboard";
import {
  servicePostCampaigns,
  getLinkOption,
  serviceAnalyzeContent,
  serviceGetCampaignDepartments,
  serviceGetCampaignProducts,
} from "services/campaign";
import { toStartOfDayIso, toEndOfDayIso } from "../../utils/campaignDate";
import { getApiErrorMessage, getPermission } from "../../utils/Utils";
import { getChannels } from "services/channel";
import { serviceGetUsersByDeparmentId } from "../../services/users";
import { getChannelIdByDepartementId } from "../../services/channel";
import { getDepartmentsAll } from "../../services/departments";
import { getTagLeadSource } from "services/tags";
import { serviceGetProfile } from "services/settings";

const AddCampaign = ({ ...props }) => {

  const [cookies] = useCookies(["user"]);
  const [linkOption, setLinkOption] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [contactOption, setContactOption] = useState([]);
  const [leadSourceOption, setLeadSourceOption] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const history = useHistory();
  const [waTargetVal, setWaTargetVal] = useState();
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [isProfileLoaded, setIsProfileLoaded] = useState(false);
  const { errors, register, handleSubmit, control, setValue, setError, clearErrors } = useForm();
  const [currentLink, setCurrentLink] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dataProfile, setDataProfile] = useState([]);
  const roleFunctions = getPermission()["campaigns"]?.access || [];

  //const { errors: errorLink, register: registerLink, handleSubmit: handleSubmitLink, setError: setErrorLink, setValue: setValueLink } = useForm();
  const [channelId, setChannelId] = useState();
  let dataSelect = {
    waTarget: [
      { value: "Rotator", label: "Rotator" },
      //{ value: "Single", label: "Single" },
    ],
  };

  const [formData, setFormData] = useState({
    link: "",
    campaignName: "",
    campaignDepartment: "",
    campaignProduct: "",
    departementTarget: "",
    waTarget: "Single",
    waNumber: "",
    message: "",
    active: true,
    shortlink: "",
    leadSourceId: "",
  });

  const [platform, setPlatform] = useState("other");
  const [contentUrl, setContentUrl] = useState("");
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const [campaignDeptOptions, setCampaignDeptOptions] = useState([]);
  const [selectedCampaignDept, setSelectedCampaignDept] = useState([]);

  const [campaignProductOptions, setCampaignProductOptions] = useState([]);
  const [selectedCampaignProducts, setSelectedCampaignProducts] = useState([]);

  const lastAnalyzedUrlRef = React.useRef("");
  const isAnalyzingRef = React.useRef(false);

  const fetchCampaignDepartments = async () => {
    try {
      const response = await serviceGetCampaignDepartments(cookies.SIDikey);
      const dataList = response?.data?.data || response?.data || [];
      if (Array.isArray(dataList)) {
        const options = dataList.map((item) => {
          if (typeof item === "string") {
            return { label: item, value: item };
          }
          const nameVal = item.name || item.departmentName || item.title || item.id || "";
          const idVal = item.id || nameVal;
          return { label: nameVal, value: idVal, raw: item };
        });
        setCampaignDeptOptions(options);
        return options;
      }
    } catch (error) {
      console.error("Error fetching campaign departments:", error);
    }
    return [];
  };

  const fetchCampaignProducts = async (deptIds = []) => {
    const ids = Array.isArray(deptIds)
      ? deptIds.filter(Boolean)
      : deptIds
      ? [deptIds]
      : [];

    if (ids.length === 0) {
      setCampaignProductOptions([]);
      return [];
    }
    try {
      const responses = await Promise.all(
        ids.map((id) => serviceGetCampaignProducts(cookies.SIDikey, id))
      );

      let combinedData = [];
      responses.forEach((response) => {
        const dataList = response?.data?.data || response?.data || [];
        if (Array.isArray(dataList)) {
          combinedData = [...combinedData, ...dataList];
        }
      });

      const uniqueMap = new Map();
      combinedData.forEach((item) => {
        if (typeof item === "string") {
          if (!uniqueMap.has(item)) {
            uniqueMap.set(item, { label: item, value: item });
          }
        } else if (item && typeof item === "object") {
          const nameVal = item.name || item.productName || item.title || item.id || "";
          const idVal = item.id || nameVal;
          const itemDeptId = item.departmentId || item.department?.id || "";
          if (!uniqueMap.has(idVal)) {
            uniqueMap.set(idVal, { label: nameVal, value: idVal, departmentId: itemDeptId, raw: item });
          }
        }
      });

      const options = Array.from(uniqueMap.values());
      setCampaignProductOptions(options);
      return options;
    } catch (error) {
      console.error("Error fetching campaign products:", error);
    }
    setCampaignProductOptions([]);
    return [];
  };


  const isValidUrlForPlatform = (url, plat) => {
    if (!url || typeof url !== "string") return false;
    const trimmed = url.trim();
    if (plat === "youtube") {
      return /^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/.+$/i.test(trimmed);
    } else if (plat === "instagram") {
      return /^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i.test(trimmed);
    }
    return true;
  };

  const handleAnalyzeContent = async (urlVal) => {
    const urlToAnalyze = urlVal !== undefined ? urlVal : contentUrl;
    if (!urlToAnalyze || (platform !== "youtube" && platform !== "instagram")) return;

    if (!isValidUrlForPlatform(urlToAnalyze, platform)) {
      setContentUrl("");
      lastAnalyzedUrlRef.current = "";
      Swal.fire({
        icon: "error",
        title: "URL Tidak Valid",
        text: `Masukkan link ${platform === "youtube" ? "YouTube (youtube.com / youtu.be)" : "Instagram (instagram.com)"} yang valid.`,
      });
      return;
    }

    setIsAnalyzing(true);
    isAnalyzingRef.current = true;
    try {
      const res = await serviceAnalyzeContent(cookies.SIDikey, {
        url: urlToAnalyze,
        platform: platform,
      });

      // Cek apakah response error
      const isSuccess = res && res.status >= 200 && res.status < 300 && res.status !== "No Server Response";
      if (!isSuccess) {
        console.warn("Analysis API returned an error response:", res);
        setContentUrl("");
        lastAnalyzedUrlRef.current = "";
        Swal.fire({
          icon: "error",
          title: "Gagal Menganalisis Konten",
          text: res?.data?.message || res?.message || "URL tidak valid atau konten tidak dapat dianalisis.",
        });
        return;
      }

      const data = res?.data?.data || res?.data;
      if (data && typeof data === "object") {
        const nameVal = data.suggestedCampaignName;
        if (nameVal) {
          setValue("campaignName", nameVal);
        }

        const linkVal = data.suggestedLinkSlug;
        if (linkVal) {
          const cleanLink = String(linkVal).replace(/[^a-zA-Z0-9\-_()]/g, '');
          setValue("link", cleanLink);
          setCurrentLink(cleanLink);
          if (typeof checkLink === "function") {
            checkLink(cleanLink);   // <-- cukup panggil fungsi yang sudah ada
          }
        }

        const msgVal = data.whatsappOpeningMessage;
        if (msgVal) {
          setValue("message", msgVal);
          clearErrors("message");
        }

        // Auto-fill Campaign Department
        let activeDeptIds = selectedCampaignDept;
        let loadedProducts = campaignProductOptions;
        const targetDept = data.suggestedDepartments;
        if (targetDept) {
          let targetDeptsList = [];
          if (Array.isArray(targetDept)) {
            targetDeptsList = targetDept;
          } else if (targetDept !== null) {
            targetDeptsList = [targetDept];
          }

          const currentDeptOpts = campaignDeptOptions.length > 0 ? campaignDeptOptions : await fetchCampaignDepartments();
          const matchedDeptValues = [];

          targetDeptsList.forEach((td) => {
            let deptIdVal = "";
            let deptNameVal = "";
            if (typeof td === "object" && td !== null) {
              deptIdVal = td.id || td.value || "";
              deptNameVal = td.name || td.label || "";
            } else if (typeof td === "string") {
              deptIdVal = td;
              deptNameVal = td;
            }

            const matched = currentDeptOpts.find(
              (opt) =>
                (deptIdVal && (String(opt.value) === String(deptIdVal) || String(opt.raw?.id) === String(deptIdVal))) ||
                (deptNameVal && opt.label.toLowerCase().trim() === deptNameVal.toLowerCase().trim())
            );

            if (matched) {
              if (!matchedDeptValues.includes(matched.value)) {
                matchedDeptValues.push(matched.value);
              }
            } else if (deptIdVal || deptNameVal) {
              const fallbackVal = deptIdVal || deptNameVal;
              if (!matchedDeptValues.includes(fallbackVal)) {
                matchedDeptValues.push(fallbackVal);
              }
            }
          });

          if (matchedDeptValues.length > 0) {
            activeDeptIds = matchedDeptValues;
            setSelectedCampaignDept(matchedDeptValues);
            setValue("campaignDepartment", matchedDeptValues, { shouldValidate: true, shouldDirty: true });
            loadedProducts = await fetchCampaignProducts(matchedDeptValues);
          }
        }

        // Auto-fill Campaign Products
        const prodVal = data.suggestedProducts || data.campaignProduct || data.product || data.productName;
        if (prodVal) {
          const currentProdOpts = loadedProducts && loadedProducts.length > 0 ? loadedProducts : (campaignProductOptions.length > 0 ? campaignProductOptions : await fetchCampaignProducts(activeDeptIds));
          let rawProdList = [];
          if (Array.isArray(prodVal)) {
            rawProdList = prodVal;
          } else if (typeof prodVal === "object" && prodVal !== null) {
            rawProdList = [prodVal];
          } else if (typeof prodVal === "string") {
            rawProdList = prodVal.split(",").map((s) => s.trim());
          }

          const matchedProdValues = [];

          rawProdList.forEach((p) => {
            let pId = "";
            let pName = "";
            if (typeof p === "object" && p !== null) {
              pId = p.id || p.value || "";
              pName = p.name || p.title || p.label || "";
            } else {
              pId = String(p || "");
              pName = String(p || "");
            }

            const matched = currentProdOpts.find(
              (opt) =>
                (pId && (String(opt.value) === String(pId) || String(opt.raw?.id) === String(pId))) ||
                (pName && opt.label.toLowerCase().trim() === pName.toLowerCase().trim())
            );

            if (matched) {
              if (!matchedProdValues.includes(matched.value)) {
                matchedProdValues.push(matched.value);
              }
            } else if (pId || pName) {
              const fallbackVal = pId || pName;
              if (!matchedProdValues.includes(fallbackVal)) {
                matchedProdValues.push(fallbackVal);
              }
            }
          });

          setSelectedCampaignProducts(matchedProdValues);
          setValue("campaignProduct", matchedProdValues, { shouldValidate: true, shouldDirty: true });
          clearErrors("campaignProduct");
        }

        Swal.fire({
          icon: "success",
          title: "Analisis Konten Berhasil",
          text: "Form berhasil diisi secara otomatis dari hasil analisis.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.error("Error analyzing content:", err);
      setContentUrl("");
      lastAnalyzedUrlRef.current = "";
      Swal.fire({
        icon: "error",
        title: "Gagal Menganalisis Konten",
        text: err?.response?.data?.message || err?.message || "Terjadi kesalahan saat menganalisis konten.",
      });
    } finally {
      setIsAnalyzing(false);
      isAnalyzingRef.current = false;
    }
  };

  const refreshContactOption = async () => {
    await getChannels(cookies.SIDikey);
    //setContactOption(responseGetChannels?.data?.data.map((item) => ({ value: item.id, label: item.phoneNumber })));
  };

  const refreshLinkOption = async () => {
    const linkOptionData = await getLinkOption({ token: cookies.SIDikey });
    console.log("linkOptionData:", linkOptionData)
    setLinkOption(linkOptionData);
  };

  //const addLink = async(submitData) => {
  //  const { linkName, description } = submitData;
  //  try{
  //  axios.interceptors.request.use((config) => {
  //    config.headers["Authorization"] = `Bearer ${cookies.SIDikey}`;
  //    config.headers["Content-Type"] = "application/json";
  //    config.headers["AccessControl-Allow-Origin"] = "http://localhost:3000";
  //    return config;
  //  });
  //  const responseCreateLink = await axios.post(process.env.REACT_APP_BASE_URL + "api/links", {
  //      name: linkName,
  //      description: description,
  //    })
  //    //console.log("responseCreateLink", responseCreateLink)
  //    return responseCreateLink
  //  } catch (error) {
  //      //console.log("error link", error);
  //      return error
  //  }
  //};

  const getProfile = async () => {
    try {
      const responseProfile = await serviceGetProfile(cookies.SIDikey);
      const resultData = responseProfile.data.departments;
      const finalData = resultData.map(department => ({
        id: department.id,
        color: department.color,
        name: department.name,
      }));
      setDataProfile(finalData);
      setIsProfileLoaded(true);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const refreshDepartmentOption = async () => {
    try {
      const responseGetDepartments = await getDepartmentsAll(
        cookies.SIDikey,
        ["Access_All_Dept"],
        "DESC",
        "department.createdAt"
      );
      let depts = responseGetDepartments.data;
  
      // Hanya filter departemen jika peran termasuk "Access_Own_Dept"
      if (roleFunctions.includes("Access_Own_Dept")) {
        const departmentsIds = dataProfile.map(item => item.id);
        depts = depts.filter(df => departmentsIds.includes(df.id));
      }
  
      const responseGetChannels = await getChannels(cookies.SIDikey);
      const deptIdsWithPhone = (responseGetChannels?.data?.data || [])
        .filter((channel) => channel.phoneNumber)
        .map((channel) => channel.departmentId);
      depts = depts.filter((dept) => deptIdsWithPhone.includes(dept.id));

      //console.log("Filtered Departments:", depts);
      setDepartmentOption(depts);
    } catch (error) {
      console.error("Error refreshing department options:", error);
      setDepartmentOption([]);
    }
  };

  const fetchLeadSource = async () => {
    const responseGetLeadSources = await getTagLeadSource(cookies.SIDikey, ["Access_All_Dept"], 0);

    // responseGetLeadSources.data.map((item) => //console.log({ value: item.id, label: item.name }));

    setLeadSourceOption(responseGetLeadSources.data.map((item) => ({ value: item.id, label: item.name })));
  };

  const onFormSubmit = async (e) => {
    if (isAnalyzingRef.current) return;
    if (!channelId || (channelId.id === "" && channelId.phone === "")) {
      Swal.fire({
        icon: "error",
        title: "Unsuccesful Create Campaign Link",
        text: "Buat channel terlebih dahulu dengan department yang dipilih sekarang",
        focusConfirm: false,
      });
      return;
    }

    const deptValues = Array.isArray(e.campaignDepartment)
      ? e.campaignDepartment
      : Array.isArray(selectedCampaignDept)
      ? selectedCampaignDept
      : selectedCampaignDept
      ? [selectedCampaignDept]
      : [];

    const deptNames = deptValues.map((val) => {
      const opt = campaignDeptOptions.find((o) => o.value === val);
      return opt ? opt.label : val;
    });

    const selectedDepartmentsPayload = deptValues.map((val) => {
      const opt = campaignDeptOptions.find((o) => o.value === val || o.label === val);
      if (opt && opt.raw && typeof opt.raw === "object") {
        return opt.raw;
      }
      return {
        id: opt ? opt.value : val,
        name: opt ? opt.label : val,
      };
    });

    const prodValues = Array.isArray(e.campaignProduct)
      ? e.campaignProduct
      : Array.isArray(selectedCampaignProducts)
      ? selectedCampaignProducts
      : selectedCampaignProducts
      ? [selectedCampaignProducts]
      : [];

    const selectedProductsPayload = prodValues.map((val) => {
      const opt = campaignProductOptions.find((o) => o.value === val || o.label === val);
      if (opt && opt.raw && typeof opt.raw === "object") {
        return opt.raw;
      }
      return {
        id: opt ? opt.value : val,
        name: opt ? opt.label : val,
      };
    });

    let submittedData = {
      linkName: e.link,
      name: e.campaignName,
      departments: selectedDepartmentsPayload,
      products: selectedProductsPayload,
      product: Array.isArray(e.campaignProduct)
      ? e.campaignProduct
          .map((val) => {
            const opt = campaignProductOptions.find((o) => o.value === val);
            return opt ? opt.label : val;
          })
          .join(",")
      : "",
      campaignDepartment: deptValues.join(","),
      campaignDepartments: deptValues,
      campaignDepartmentIds: deptValues,
      campaignDepartmentNames: deptNames.join(","),
      campaignLink: contentUrl || e.campaignLink || "",
      departmentId: e.departementTarget,
      waTarget: e.waTarget,
      channelId: channelId.id,
      message: e.message,
      status: formData.active ? "ACTIVE" : "INACTIVE",
      noWa: "+" + channelId.phone,
      userId: e.waNumber?.value,
      username: e.waNumber?.label,
      leadSourceId: selectedLeadSource,
      startDate: startDate ? toStartOfDayIso(startDate) : null,
      endDate: endDate ? toEndOfDayIso(endDate) : null,
    };

    if (startDate && endDate && endDate < startDate) {
      Swal.fire({
        icon: "error",
        title: "Tanggal tidak valid",
        text: "Tanggal selesai harus setelah tanggal mulai",
        focusConfirm: false,
      });
      return;
    }

    setFormData({
      link: e.link,
      campaignProduct: Array.isArray(e.campaignProduct)
      ? e.campaignProduct
          .map((val) => {
            const opt = campaignProductOptions.find((o) => o.value === val);
            return opt ? opt.label : val;
          })
          .join(",")
      : "",
      campaignLink: contentUrl || e.campaignLink || "",
      departementTarget: e.departementTarget,
      shortlink: "https://astronacci.org/" + e.link,
    });
    const responsePostCampaign = await servicePostCampaigns(cookies.SIDikey, submittedData);
    const isSuccess =
      (typeof responsePostCampaign?.status === "number" &&
        responsePostCampaign.status >= 200 &&
        responsePostCampaign.status < 300 &&
        responsePostCampaign.status !== "No Server Response") ||
      responsePostCampaign?.statusText === "Created" ||
      responsePostCampaign?.statusText === "OK" ||
      responsePostCampaign?.statusText === "Accepted";

    if (!isSuccess) {
      const errorMessage = getApiErrorMessage(responsePostCampaign, "Gagal membuat campaign.");
      Swal.fire({
        icon: "error",
        title: "Unsuccesful Create Campaign Link",
        text: errorMessage,
        focusConfirm: false,
      });
      return;
    }
    setSuccessModal(true);
    // reset({});
  };

  const onActiveCheck = (e) => {
    setFormData((prev) => ({
      ...prev,
      active: !prev.active,
    }));
  };

  // Effect to initialize data and refresh department options
  useEffect(() => {
    getProfile(); // Fetch profile data
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isProfileLoaded) {
      refreshDepartmentOption();
      refreshLinkOption();
      refreshContactOption();
      fetchLeadSource();
      fetchCampaignDepartments();
    }
  }, [isProfileLoaded]);  // eslint-disable-line react-hooks/exhaustive-deps

  // Department change
  const departementSelected = useCallback(
    async (departmentId) => {
      const responseGetUsers = await serviceGetUsersByDeparmentId(cookies.SIDikey, departmentId.value);
      const channelId = await getChannelIdByDepartementId(cookies.SIDikey, departmentId.value);
      const waTarget = responseGetUsers.map((user) => {
        return {
          value: user.id,
          label: user.firstName + " " + user.lastName,
        };
      });
      setContactOption(waTarget);
      const channelWithPhone = channelId?.data?.data?.find((channel) => channel.phoneNumber);
      if (channelWithPhone) {
        setChannelId({
          phone: channelWithPhone.phoneNumber,
          id: channelWithPhone.id,
        });
      } else {
        setChannelId({
          phone: "",
          id: "",
        });
      }
      clearErrors("departementTarget");
    },
    [cookies.SIDikey] // eslint-disable-line react-hooks/exhaustive-deps
  );
  //console.log("channelid", channelId);
  const checkLink = useCallback(
    (name) => {
      const uniqLink = Array.isArray(linkOption)
        ? linkOption.find((link) => link.name === name)
        : null;
      if (uniqLink) {
        setError("link", { type: "error", message: "Name link harus unik!" });
      } else {
        clearErrors("link");
        setValue("link", name);
        setCurrentLink(name);
      }
    },
    [clearErrors, linkOption, setError, setValue]
  );

  return (
    <React.Fragment>
      <Head title="Add Campaign" />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle tag="h3" page>
              Campaign
            </BlockTitle>
          </BlockHeadContent>
        </BlockHead>

        <Block>
          <Card className="p-4">
            <BlockHead>
              <BlockBetween>
                <BlockHeadContent>
                  <strong style={{ fontSize: 18 }}>Tambah Campaign</strong>
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>
            <Block>
              <Form key="addData" className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                <Col md="6" lg="6">
                  <FormGroup className="form-group">
                    <label className="form-label">Platform</label>
                    <div className="form-control-wrap">
                      <ul className="custom-control-group g-3 align-center">
                        <li>
                          <div className="custom-control custom-radio">
                            <input
                              disabled={isAnalyzing}
                              type="radio"
                              className="custom-control-input"
                              name="platform"
                              id="platformYoutube"
                              value="youtube"
                              checked={platform === "youtube"}
                              onChange={(e) => {
                                setPlatform(e.target.value);
                              }}
                            />
                            <label className="custom-control-label" htmlFor="platformYoutube">
                              YouTube
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="custom-control custom-radio">
                            <input
                              disabled={isAnalyzing}
                              type="radio"
                              className="custom-control-input"
                              name="platform"
                              id="platformInstagram"
                              value="instagram"
                              checked={platform === "instagram"}
                              onChange={(e) => {
                                setPlatform(e.target.value);
                              }}
                            />
                            <label className="custom-control-label" htmlFor="platformInstagram">
                              Instagram
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="custom-control custom-radio">
                            <input
                              disabled={isAnalyzing}
                              type="radio"
                              className="custom-control-input"
                              name="platform"
                              id="platformOther"
                              value="other"
                              checked={platform === "other"}
                              onChange={(e) => {
                                setPlatform(e.target.value);
                              }}
                            />
                            <label className="custom-control-label" htmlFor="platformOther">
                              Other
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </FormGroup>

                  {(platform === "youtube" || platform === "instagram") && (
                    <FormGroup className="form-group">
                      <label className="form-label">
                        URL Content ({platform === "youtube" ? "YouTube" : "Instagram"})
                      </label>
                      <div className="form-control-wrap">
                        <input
                          disabled={isAnalyzing}
                          type="text"
                          className="form-control"
                          name="campaignLink"
                          placeholder={`Masukkan link ${platform === "youtube" ? "YouTube" : "Instagram"}...`}
                          value={contentUrl}
                          onChange={(e) => {
                            setContentUrl(e.target.value);
                            setValue("campaignLink", e.target.value);
                          }}
                          onKeyDown={(e) => {
                            // Enter = trigger analyze (via blur), bukan submit form
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.target.blur();
                            }
                          }}
                          onBlur={(e) => {
                            const val = e.target.value;
                            if (val && val !== lastAnalyzedUrlRef.current) {
                              lastAnalyzedUrlRef.current = val;
                              handleAnalyzeContent(val);
                            }
                          }}
                          ref={register()}
                        />
                        {isAnalyzing && (
                          <span className="form-note text-primary mt-1">
                            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                            Menganalisis konten...
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  )}
                  <FormGroup>
                    <label className="form-label">Link</label>
                    <input
                      disabled={isAnalyzing}
                      className="form-control"
                      type="text"
                      name="link"
                      placeholder="Nama Link..."
                      ref={register({
                        required: "This field is required",
                        pattern: {
                          value: /^[a-zA-Z0-9\-_()]+$/,
                          message: "Only alphabets, numbers, and -_() are allowed"
                        }
                      })}
                      onInput={(e) => {
                        // Sanitize input to only allow the specified characters
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9\-_()/.]/g, '');
                        const urlEncode = encodeURIComponent(e.target.value);
                        checkLink(urlEncode);
                      }}
                      onPaste={(e) => {
                        // Prevent default paste behavior
                        e.preventDefault();
                      }}
                      onKeyDown={(e) => {
                        // Get the pressed key
                        const key = e.key || String.fromCharCode(e.keyCode || e.which);

                        // Check if the key is not allowed (not an alphabet, number, or one of -_())
                        const allowedPattern = /^[a-zA-Z0-9\-_()]$/;

                        // Allow control keys like Backspace, Delete, arrows, etc.
                        const isControlKey = e.ctrlKey || e.metaKey || 
                          ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'].includes(e.key);

                        if (!allowedPattern.test(key) && !isControlKey) {
                          e.preventDefault();
                          e.stopPropagation();
                          return false;
                        }
                      }}
                    ></input>

                    {errors.link && (
                      <span className="invalid text-danger font-italic" style={{ fontSize: "11px" }}>
                        {errors.link.message}
                      </span>
                    )}
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label">Campaign Name</label>
                    <input
                      disabled={isAnalyzing}
                      className="form-control"
                      type="text"
                      name="campaignName"
                      defaultValue={formData.campaignName}
                      ref={register({
                        required: "This field is required",
                      })}
                    ></input>
                    {errors.campaignName && <span className="invalid">{errors.campaignName?.message}</span>}
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label">Campaign Department</label>
                    <RSelect
                      isMulti
                      isDisabled={isAnalyzing}
                      name="campaignDepartment"
                      options={campaignDeptOptions}
                      placeholder="Pilih Campaign Department..."
                      value={campaignDeptOptions.filter(
                        (opt) =>
                          selectedCampaignDept.includes(opt.value) ||
                          selectedCampaignDept.includes(opt.label)
                      )}
                      onChange={(selected) => {
                        const values = selected ? selected.map((item) => item.value) : [];
                        setSelectedCampaignDept(values);
                        setValue("campaignDepartment", values);
                        setSelectedCampaignProducts([]);
                        setValue("campaignProduct", []);
                        if (values.length > 0) {
                          fetchCampaignProducts(values);
                        } else {
                          setCampaignProductOptions([]);
                        }
                      }}
                      {...register("campaignDepartment")}
                    />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <label className="form-label">Campaign Product</label>
                    <RSelect
                      isMulti
                      isDisabled={isAnalyzing}
                      name="campaignProduct"
                      options={campaignProductOptions}
                      placeholder="Pilih Campaign Product..."
                      value={campaignProductOptions.filter(
                        (opt) =>
                          selectedCampaignProducts.includes(opt.value) ||
                          selectedCampaignProducts.includes(opt.label)
                      )}
                      onChange={(selected) => {
                        const values = selected ? selected.map((item) => item.value) : [];
                        setSelectedCampaignProducts(values);
                        setValue("campaignProduct", values);
                        clearErrors("campaignProduct");
                      }}
                      {...register("campaignProduct", { required: selectedCampaignProducts.length === 0 })}
                    />
                    {errors.campaignProduct && selectedCampaignProducts.length === 0 && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  {platform === "other" && (
                    <FormGroup>
                      <label className="form-label">Link Referensi</label>
                      <input
                        disabled={isAnalyzing}
                        className="form-control"
                        type="text"
                        name="campaignLink"
                        placeholder="Link referensi campaign (opsional)..."
                        value={contentUrl}
                        onChange={(e) => {
                          setContentUrl(e.target.value);
                          setValue("campaignLink", e.target.value);
                        }}
                        ref={register()}
                      />
                    </FormGroup>
                  )}

                  <FormGroup>
                    <label className="form-label">Department Target</label>

                    <RSelect
                      isDisabled={isAnalyzing}
                      name="departementTarget"
                      options={departmentOption?.map((item) => ({ label: item?.name, value: item.id }))}
                      placeholder="Pilih Department"
                      onChange={(e) => {
                        setValue("departementTarget", e.value);
                        departementSelected(e);
                        setSelectedDept(e.value);
                      }}
                      defaultValue={""}
                      {...register("departementTarget", { required: true })}
                    ></RSelect>
                    {errors.departementTarget && !selectedDept && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">WA Target</label>
                    <RSelect
                      isDisabled={isAnalyzing}
                      name="waTarget"
                      options={dataSelect.waTarget}
                      placeholder="Pilih target"
                      onChange={(e) => {
                        setValue("waTarget", e.value);
                        setWaTargetVal(e.value);
                      }}
                      {...register("waTarget", { required: true })}
                      defaultValue={""}
                    ></RSelect>
                    {errors.waTarget && !waTargetVal && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>
                  {waTargetVal === "Single" && (
                    <FormGroup className={formData.waTarget === "Single" ? "" : "d-none"}>
                      <label className="form-label">User</label>
                      <Controller
                        as={RSelect}
                        control={control}
                        rules={{ required: true }}
                        name="waNumber"
                        options={contactOption}
                        isDisabled={isAnalyzing}
                        // onChange={(e) => waNumberSelected(e)}
                        placeholder="Pilih Nomor WA"
                        defaultValue={formData.waNumber}
                      />
                      {errors.waNumber && (
                        <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                          This field is required
                        </span>
                      )}
                    </FormGroup>
                  )}
                  <FormGroup>
                    <label className="form-label">Campaign Lead Source</label>
                    <RSelect
                      isDisabled={isAnalyzing}
                      name="leadSource"
                      options={leadSourceOption?.map((item) => ({ label: item?.label, value: item.value }))}
                      placeholder="Pilih Lead Source"
                      value={leadSourceOption?.find((item) => item.value === selectedLeadSource) || null}
                      onChange={(e) => {
                        setValue("leadSourceId", e?.value || "", { shouldValidate: true, shouldDirty: true });
                        setSelectedLeadSource(e?.value || "");
                        clearErrors("leadSourceId");
                      }}
                      {...register("leadSourceId", { required: true })}
                    ></RSelect>
                    {errors.leadSourceId && !selectedLeadSource && (
                      <span className="text-danger font-italic" style={{ fontSize: "11px" }}>
                        This field is required
                      </span>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <div className="custom-control custom-checkbox">
                      <input
                        disabled={isAnalyzing}
                        type="checkbox"
                        className="custom-control-input form-control"
                        id="newActive"
                        name="active"
                        defaultChecked={formData.active}
                        defaultValue={formData.active}
                        onChange={onActiveCheck}
                      />
                      <label className="custom-control-label" htmlFor="newActive">
                        Aktif
                      </label>
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">Tanggal Mulai (opsional)</label>
                    <DatePicker
                      disabled={isAnalyzing}
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      dateFormat="yyyy-MM-dd"
                      className="form-control date-picker"
                      placeholderText="Pilih tanggal mulai"
                      isClearable={!isAnalyzing}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">Tanggal Selesai (opsional)</label>
                    <DatePicker
                      disabled={isAnalyzing}
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      dateFormat="yyyy-MM-dd"
                      className="form-control date-picker"
                      placeholderText="Pilih tanggal selesai"
                      isClearable={!isAnalyzing}
                    />
                  </FormGroup>
                </Col>
                <Col md="6" lg="6">
                  <div className="mt-5" style={{ fontSize: 14 }}>
                    <strong>
                      <span>https://astronacci.org/</span>
                      <span style={{ color: "#4461F2" }}>{currentLink}</span>
                    </strong>
                  </div>
                  <FormGroup>
                    <label className="form-label">Pesan Pembuka</label>
                    <textarea
                      disabled={isAnalyzing}
                      className="form-control"
                      name="message"
                      ref={register({
                        required: "This field is required",
                      })}
                    />
                    {errors.message && <span className="invalid">{errors.message.message}</span>}
                  </FormGroup>
                  <Block className="py-3">
                    <Card className="card-bordered card-bluesky p-2">
                      <strong>Pesan pembuka akan muncul saat customer akan memulai percakapan</strong>
                    </Card>
                  </Block>
                </Col>
                <Col size="12">
                  <Link
                    to={isAnalyzing ? "#" : `${process.env.PUBLIC_URL + "/campaign"}`}
                    style={isAnalyzing ? { pointerEvents: "none" } : undefined}
                  >
                    <Button outline type="button" color="primary" className="mr-3" disabled={isAnalyzing}>
                      Batal
                    </Button>
                  </Link>
                  <Button color="primary" type="submit" disabled={isAnalyzing}>
                    {isAnalyzing ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Menganalisis...
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </Button>
                </Col>
              </Form>
            </Block>
          </Card>
        </Block>
        {/*
        <Modal
          isOpen={addLinkModal}
          toggle={() => setAddLinkModal(false)}
          backdrop="static"
          keyboard={false}
          className="modal-dialog-centered"
          size="xs"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setAddLinkModal(false);
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Tambah Link</h5>
              <div className="mt-4">
                <Form key="link" className="row gy-4" onSubmit={handleSubmitLink(addLink)}>
                  <Col md="12" xs="12" lg="12">
                    <FormGroup>
                      <label>Nama Link</label>
                      <input
                        className="form-control"
                        type="text"
                        name="linkName"
                        placeholder="Nama Link..."
                        ref={registerLink({ required: "This field is required" })}
                        onInput={(e) => {
                          const urlEncode = encodeURIComponent(e.target.value)
                          setValueLink(urlEncode)
                          checkLink(urlEncode)
                        }}
                        onPaste={(e) => e.preventDefault()}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                      />
                      {errorLink.linkName && <span className="invalid">{errorLink.linkName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12" xs="12" lg="12">
                    <FormGroup>
                      <label>Catatan</label>
                      <input
                        className="form-control"
                        type="text"
                        name="description"
                        placeholder="Tambah Catatan..."
                        ref={registerLink({ required: "This field is required" })}
                      />
                      {errorLink.description && <span className="invalid">{errorLink.description.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12" xs="12" lg="12">
                    <Button type="submit" color="primary">
                      Simpan
                    </Button>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
                      */}
        <Modal
          onClosed={() => history.push(`${process.env.PUBLIC_URL}/campaign`)}
          isOpen={successModal}
          toggle={() => {
            setSuccessModal(false);
          }}
        >
          <ModalBody>
            <div className="d-flex flex-column align-items-center">
              <h6 className="text-center text-primary">Yay! your link has been created successfully</h6>
              {/* <div className="d-flex justify-content-center mt-2">
                <a
                  href={formData.shortlink}
                  target="_blank"
                  className={classNames({ "selector-active": toggleLink }, "text-center link-modal-button-selector")}
                  onClick={() => {
                    setToggleLink(true);
                  }}
                  rel="noreferrer"
                >
                  <Icon name="link " style={{ fontSize: "70px" }} />
                  <p className="font-weight-bold" style={{ fontSize: "20px" }}>
                    LINK
                  </p>
                </a>
                <div
                  className={classNames({ "selector-active": !toggleLink }, "text-center link-modal-button-selector")}
                  onClick={() => setToggleLink(false)}
                >
                  <Icon name="qr " style={{ fontSize: "70px" }} />
                  <p className="font-weight-bold" style={{ fontSize: "20px" }}>
                    QR CODE
                  </p>
                </div>
              </div> */}
              {/* <div className="my-5">
                {!toggleLink ? (
                  <>
                    <QRCode value={formData.shortlink} size={225} fgColor="#545454" />{" "}
                  </>
                ) : (
                  <div className="d-flex">
                    <input
                      type="text"
                      value={formData.shortlink.replace(/\s/g, "")}
                      disabled
                      className="rounded-left"
                    />
                    <Tooltip
                      placement="top"
                      isOpen={tooltipOpen}
                      toggle={() => setTooltipOpen(false)}
                      target="copy-tooltip"
                    >
                      Copied!
                    </Tooltip>
                    <CopyToClipboard text={formData.shortlink} onCopy={() => setTooltipOpen(true)}>
                      <div className="copy-link-button rounded-right" id="copy-tooltip">
                        <p>Copy Link</p>
                      </div>
                    </CopyToClipboard>
                  </div>
                )}
              </div> */}
              <div className="my-5">
                <QRCode value={formData?.shortlink || ""} size={225} fgColor="#545454" />{" "}
                <div className="d-flex mt-5">
                  <input
                    type="text"
                    value={formData?.shortlink ? formData.shortlink.replace(/\s/g, "") : ""}
                    disabled
                    className="rounded-left"
                  />
                  <Tooltip
                    placement="top"
                    isOpen={tooltipOpen}
                    toggle={() => setTooltipOpen(false)}
                    target="copy-tooltip"
                  >
                    Copied!
                  </Tooltip>
                  <CopyToClipboard text={formData?.shortlink || ""} onCopy={() => setTooltipOpen(true)}>
                    <div className="copy-link-button rounded-right" id="copy-tooltip">
                      <p>Copy Link</p>
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
              <a href="/campaign" className="text-center">
                Simpan <span>{">"}</span>
              </a>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default AddCampaign;
